import React from "react";
import { Link, useLocation } from "react-router-dom";
import { programData } from "../data/programData";

const NavbarProgram: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="bg-sub shadow-md border-b border-gray-300">
      <div className="max-w-6xl mx-auto px-4">
        {/* Horizontal scroll for mobile, centered on desktop */}
        <div className="flex items-center h-12 overflow-x-auto scrollbar-hide md:justify-start space-x-6">
          {programData.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap font-medium transition-colors pb-1
                ${
                  location.pathname === item.to
                    ? "text-accent border-b-2 border-accent"
                    : "text-main hover:text-hover"
                }
              `}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default NavbarProgram;
